import BackgroundGroupComponent from '../components/PageGroup/BackgroundGroup/viewer/BackgroundGroup';


const BackgroundGroup = {
  component: BackgroundGroupComponent
};


export const components = {
  ['BackgroundGroup']: BackgroundGroup
};

